// Чат с оператором — сторонний виджет Chaport (подключается в index.html).
// Его стартовая форма спрашивала у клиента имейл, хотя клиент уже вошёл в
// кабинет и имейл нам известен — заказчик прислал это замечанием. Представляем
// посетителя виджету, и известные поля он больше не спрашивает.
const identifyInChat = () => {
  try {
    const userData = JSON.parse(localStorage.getItem('userData'))
    const email = userData && userData.login
    if (!email || !window.chaport) return
    window.chaport.q('setVisitorData', { email })
  } catch (e) {
    // Чат — не критичная функция: без представления просто спросит имейл сам.
  }
}

export default identifyInChat
